var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 30,
    viewBox: "0 0 194 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_516_20733",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 82,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 0H112V30H82V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_516_20733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.0457 4H102.264C103.041 4 103.671 3.37041 103.671 2.59375C103.671 1.81709 103.041 1.1875 102.264 1.1875H98.0457C97.269 1.1875 96.6394 1.81709 96.6394 2.59375C96.6394 3.37041 97.269 4 98.0457 4Z",
    fill: "#FF7480"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.164 28.813C93.9508 28.813 88.9141 23.7762 88.9141 17.563C88.9141 11.3498 93.9508 6.31299 100.164 6.31299C106.377 6.31299 111.414 11.3498 111.414 17.563C111.414 23.7762 106.377 28.813 100.164 28.813Z",
    fill: "#5DDEF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.295 26.9984C101.934 29.8383 96.036 29.3448 92.2091 25.5179C87.8157 21.1245 87.8157 14.0014 92.2091 9.60803C96.6025 5.21461 103.726 5.21461 108.119 9.60803C111.942 13.4313 112.438 19.3218 109.607 23.6816",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.165 26.0669C95.4689 26.0669 91.6617 22.2597 91.6617 17.5632C91.6617 12.8668 95.4689 9.05959 100.165 9.05959C104.862 9.05959 108.669 12.8668 108.669 17.5632C108.669 22.2597 104.862 26.0669 100.165 26.0669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.165 26.0669C95.4689 26.0669 91.6617 22.2597 91.6617 17.5632C91.6617 12.8668 95.4689 9.05959 100.165 9.05959C104.862 9.05959 108.669 12.8668 108.669 17.5632C108.669 22.2597 104.862 26.0669 100.165 26.0669Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0457 4H102.264C103.041 4 103.671 3.37041 103.671 2.59375C103.671 1.81709 103.041 1.1875 102.264 1.1875H98.0457C97.269 1.1875 96.6394 1.81709 96.6394 2.59375C96.6394 3.37041 97.269 4 98.0457 4Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.16 6.31299V3.99994H98.1511V6.31299",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.275 16.4521L104.285 13.442",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9281 17.563C98.9281 18.245 99.4809 18.7979 100.163 18.7979C100.845 18.7979 101.398 18.245 101.398 17.563C101.398 16.8811 100.845 16.3282 100.163 16.3282C99.4809 16.3282 98.9281 16.8811 98.9281 17.563Z",
    fill: "#FF838E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9281 17.563C98.9281 18.245 99.4809 18.7979 100.163 18.7979C100.845 18.7979 101.398 18.245 101.398 17.563C101.398 16.8811 100.845 16.3282 100.163 16.3282C99.4809 16.3282 98.9281 16.8811 98.9281 17.563Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.429 17.5698H105.886",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9 17.5562H94.4428",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.17 11.298V11.8408",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.158 23.8276V23.2848",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.238 16.6362L97.6472 15.0455",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.037 16.6899L104.2 13.5275",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4274 21.1782H84.9297",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9141 17.7544H85.75",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2711 14.3301H82.5859",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7548 10.9062H86.5793",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.52f3fbda7f7758670feeaff289363665.svg";
export { ForwardRef as ReactComponent };